<!-- 游戏房间入口 -->
<template>
  <li
    :class="[
      'GameRoomEntrance-Component',
      'game-room-item',
      {
        'response-room-item': responsive,
        'only-show-first-row': onlyShowFirstRow
      }
    ]"
  >
    <nuxt-link
      :to="localePath(`/${roomInfo.bigoID || roomInfo.bigo_id}`)"
      :title="roomInfo.room_topic || roomInfo.nick_name"
    >
      <div class="game-room-item__cover">
        <div
          v-lazy-container="{
            selector: 'img',
            error: defaultCover,
            loading: defaultCover
          }"
          class="img-box"
        >
          <img
            :data-src="roomInfo.cover_l ? roomInfo.cover_l : roomInfo.data5"
            :alt="roomInfo.room_topic || roomInfo.room_remark || 'bigo'"
          />

          <div v-if="roomInfo.user_count >= 1000" class="hot-icon"></div>
        </div>
      </div>
      <div class="game-room-item__detail-box">
        <div class="avatar-thumb">
          <img
            v-lazy="
              roomInfo.data5 ||
                'https://static-web.likeevideo.com/as/bigo-static/www.bigo.tv/img/logo_icon.png'
            "
            :alt="roomInfo.nick_name"
          />
        </div>

        <p
          v-if="
            roomInfo.room_topic.replace(/(^\s*)/g, '') || roomInfo.room_remark
          "
          class="room-name"
        >
          {{
            roomInfo.room_topic.replace(/(^\s*)/g, '') || roomInfo.room_remark
          }}
        </p>
        <div
          :class="[
            'name-box',
            {
              'name-box-max-width': !(
                roomInfo.room_topic.replace(/(^\s*)/g, '') ||
                roomInfo.room_remark
              )
            }
          ]"
        >
          {{ roomInfo.nick_name }}
        </div>
        <span class="viewer-num">
          {{ roomInfo.user_count }}
        </span>
      </div>
      <div class="hover-bg-box"><span class="hover-bg"></span></div>
    </nuxt-link>
  </li>
</template>

<script>
export default {
  components: {},
  props: {
    roomInfo: {
      type: Object,
      default: () => ({})
    },
    // 是否随窗口大小改变尺寸
    responsive: {
      type: Boolean,
      default: false
    },
    // 是否只显示第一行
    onlyShowFirstRow: {
      type: Boolean,
      default: false
    }
  },
  data() {
    this.defaultCover =
      'data:image/jpeg;base64,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';
    return {};
  }
};
</script>
<style lang="scss" scoped>
@import '~assets/scss/mixin.scss';

.game-room-item {
  display: block;
  float: left;
  position: relative;
  margin-bottom: 20px;

  a {
    display: block;
    margin-right: 20px;
  }

  img {
    width: 100%;
    height: 100%;
  }

  .game-room-item__cover {
    height: 140px;
    width: 250px;
    position: relative;

    .img-box {
      width: 100%;
      height: 100%;

      img {
        border-top-left-radius: 4px;
        border-top-right-radius: 4px;
        object-fit: cover;
        width: 100%;
        height: 100%;
      }
    }

    .hot-icon {
      position: absolute;
      right: 8px;
      top: 8px;
      width: 46px;
      height: 19px;
      background-repeat: no-repeat;
      background-position: center center;
      background-size: cover;
      background-image: url('~@assets/img/hot.png');
    }
  }

  .game-room-item__detail-box {
    position: relative;
    height: 66px;
    padding: 0 7px;
    padding-top: 14px;
    z-index: 9;
    background-color: #fff;
    border-bottom-left-radius: 4px;
    border-bottom-right-radius: 4px;

    .avatar-thumb {
      width: 38px;
      height: 38px;
      float: left;
      margin-right: 7px;

      img {
        border-radius: 50%;
      }
    }

    .room-name {
      @include els();

      font-size: 16px;
      font-weight: 500;
      color: #2f3033;
      line-height: 19px;
      max-width: 140px;
    }

    .name-box {
      @include els();

      font-size: 14px;
      font-weight: 400;
      color: #8a8f99;
      line-height: 16px;
      margin-top: 3px;

      &.name-box-max-width {
        max-width: 145px;
      }
    }

    .viewer-num {
      position: absolute;
      right: 12px;
      bottom: 34px;
      display: block;
      font-size: 14px;
      font-weight: 400;
      color: #8a8f99;
      line-height: 16px;

      &::before {
        content: '';
        float: left;
        position: relative;
        top: 1px;
        width: 14px;
        height: 14px;
        margin-right: 3px;
        background-repeat: no-repeat;
        background-position: center center;
        background-size: cover;
        background-image: url('~@assets/img/people.png');
      }
    }
  }

  &:hover .hover-bg-box,
  &:hover .hover-bg {
    z-index: 9;
    opacity: 1;
    filter: alpha(opacity=100);
    transform: scale(1);
  }

  &.response-room-item {
    a {
      margin-right: 23px;
    }
  }
}

.hover-bg-box {
  position: absolute;
  top: 0;
  left: 0;
  right: 20px;
  bottom: 66px;
  z-index: -1;
  background: rgba(0, 0, 0, 0.5);
  opacity: 0;
  filter: alpha(opacity=0);
  transition: all 0.2s;
  border-radius: 3px;

  .hover-bg {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    width: 54px;
    height: 54px;
    z-index: -1;
    margin-top: -27px;
    margin-left: -27px;
    opacity: 0;
    background: url(~@assets/img/video_h.png) center no-repeat;
    transform: scale(2);
    transition: all ease-out 250ms;
    filter: alpha(opacity=0);
  }
}

// .only-show-first-row {
//   display: none;
// }

// @media (min-width: 1601px) {
//   .response-room-item {
//     width: 16.666%;

//     &.only-show-first-row:nth-child(1),
//     &.only-show-first-row:nth-child(2),
//     &.only-show-first-row:nth-child(3),
//     &.only-show-first-row:nth-child(4),
//     &.only-show-first-row:nth-child(5),
//     &.only-show-first-row:nth-child(6) {
//       display: block;
//     }

//     .game-room-item__cover {
//       width: auto;
//       height: auto;
//     }
//   }
// }

// @media (min-width: 1301px) and (max-width: 1600px) {
//   .response-room-item {
//     width: 20%;

//     &.only-show-first-row:nth-child(1),
//     &.only-show-first-row:nth-child(2),
//     &.only-show-first-row:nth-child(3),
//     &.only-show-first-row:nth-child(4),
//     &.only-show-first-row:nth-child(5) {
//       display: block;
//     }

//     .game-room-item__cover {
//       width: auto;
//       height: auto;
//     }
//   }
// }
// @media (max-width: 1300px) {
//   .response-room-item {
//     width: 25%;

//     &.only-show-first-row:nth-child(1),
//     &.only-show-first-row:nth-child(2),
//     &.only-show-first-row:nth-child(3),
//     &.only-show-first-row:nth-child(4) {
//       display: block;
//     }

//     .game-room-item__cover {
//       width: auto;
//       height: auto;
//     }
//   }
// }
</style>
